/**
 * Phase 2P — Owner-authorized TEST hotels-only UI Book unlock.
 *
 * Does NOT flip global dual gates:
 *   HUBWAYZ_SUPPLIER_BOOK_EXECUTION_ALLOWED
 *   HUBWAYZ_SUPPLIER_BOOK_DISPATCH_UNLOCK
 *
 * Armed by explicit owner authorization for Hubwayz TEST (mishor5).
 * Backend must still enforce TEST host + session; FE alone is insufficient.
 */

/** Production release: the browser must not send supplier Book. */
export const HUBWAYZ_UI_TEST_HOTELS_BOOK_ARMED = false;

/** Header sent to BE so server can authorize the scoped Book. */
export const HUBWAYZ_UI_TEST_BOOK_HEADER = "X-Hubwayz-Ui-Test-Book";

export function isHubwayzUiTestHotelsBookArmed() {
  return HUBWAYZ_UI_TEST_HOTELS_BOOK_ARMED === true;
}

/**
 * Fail-closed evaluation for UI hotels-only live Book.
 * @param {{ paymentMethodName?: string, hotelsOnly?: boolean }} [input]
 */
export function evaluateHubwayzUiTestHotelsBookUnlock(input = {}) {
  const armed = isHubwayzUiTestHotelsBookArmed();
  const paymentMethod = String(input.paymentMethodName || "account_credit").trim();
  const hotelsOnly = input.hotelsOnly !== false;

  if (!armed) {
    return {
      permitted: false,
      path: "ui_test_hotels_only",
      code: "ui_test_hotels_book_disarmed",
      message: "UI TEST hotels Book unlock is disarmed",
      globalDualGatesUsed: false,
    };
  }
  if (!hotelsOnly) {
    return {
      permitted: false,
      path: "ui_test_hotels_only",
      code: "hotels_only_required",
      message: "UI TEST Book requires hotels-only isolation",
      globalDualGatesUsed: false,
    };
  }
  if (paymentMethod !== "account_credit") {
    return {
      permitted: false,
      path: "ui_test_hotels_only",
      code: "payment_method_must_be_account_credit",
      message: "UI TEST Book requires paymentMethod=account_credit",
      globalDualGatesUsed: false,
    };
  }
  return {
    permitted: true,
    path: "ui_test_hotels_only",
    code: "ui_test_hotels_book_permitted",
    message: "UI TEST hotels-only Book unlock permitted (BE must still authorize)",
    globalDualGatesUsed: false,
    paymentMethod,
  };
}
